/* 
  系统管理-菜单管理
*/
import request from "@/utils/request";

//接口
interface data {
  menuId: string | undefined; // 当前菜单id
  resourceId: string | undefined; // 修改项的资源id
}
// interface data1 {
//   isEnable: string | undefined ;
//   menuCode: boolean | undefined ;
//   menuDescription: string | undefined ;
//   menuHref: string | undefined ;
//   menuIcon: string | undefined ;
//   menuName: string | undefined ;
//   menuOrder: number | undefined ;
//   menuType: string | undefined ;
//   menuParentId: number | undefined ;
//   id: string | undefined ; // 修改菜单用到的id，我也不确定哎
// }

interface data1 {
  menuName: string | undefined;
  menuCode: string | undefined;
  menuType: string | undefined;
  menuHref: string | undefined;
  // resourceMethod: string | undefined;
  menuOrder: number | undefined; // 序号要前端特别校验
  isEnable: boolean | undefined;
  menuDescription: string | undefined;
  menuIcon: "";
  menuParentId: number | undefined;
  menuId: string | undefined; // 修改菜单用到的id，我也不确定哎
}

interface data2 {
  id: string | undefined;
}
// interface  data2{
//   current: any,
//   menuId: string,
//   size: any
// }
/*------------------- 菜单部分开始------------------------*/
// 获取考务所有菜单树数据
function getAllMenuTreeList() {
  return request({
    url: `/baseMenu/allMenuTreeList`,
    method: "get"
  });
}

// 新增菜单数据
function postMenuData(param: object) {
  return request({
    url: `/baseMenu`,
    method: "post",
    data: param
  });
}
// 根据id获取菜单数据
function getMenuDataById(menuId) {
  return request({
    url: `/baseMenu/get/${menuId}`,
    method: "get"
  });
}
// 修改菜单数据
function putMenuData(param: data1) {
  return request({
    url: `/baseMenu/${param.menuId}`,
    method: "put",
    data: param
  });
}
// 删除菜单数据
function delMenuData(id: any) {
  return request({
    url: `/baseMenu/${id}`,
    method: "delete"
  });
}

/*------------------- 菜单部分结束------------------------*/
/*------------------- 资源部分开始------------------------*/
// 获取 userTableData 展示数据
// function getuserTableData(param) {
function getuserTableData(data: object) {
  return request({
    url: `/baseMenuResource/getPage`,
    method: "post",
    // data: {
    //   "current": 1,
    //   "isEnable": "TRUE",
    //   "menuId": 1,
    //   "resourceCodeOrName": "资源名称或编码",
    //   "size": 15
    // }
    data
  });
}
// 新增资源数据 /baseMenuResource/{id}
// http://10.4.63.11:8010/baseMenuResource/101
function postuserTableData(param: data) {
  return request({
    url: `/baseMenuResource/${param.menuId}`,
    method: "post",
    // data:param
    data: param
  });
}
// 修改资源数据 /baseMenuResource/{id}
function putUserTableData(param: data) {
  return request({
    url: `/baseMenuResource/${param.resourceId}`,
    method: "put",
    // data:param
    data: param
  });
}
// 删除资源数据 /baseMenuResource/{id}
function delUserTableData(ids: Array<string>) {
  return request({
    url: `/baseMenuResource/batchDel/`,
    method: "delete",
    // data:param
    data: ids // ids['resourceId','resourceId']
  });
}

/*------------------- 资源部分结束------------------------*/

export {
  getAllMenuTreeList,
  getuserTableData,
  postuserTableData,
  putUserTableData,
  delUserTableData,
  postMenuData,
  putMenuData,
  delMenuData,
  getMenuDataById
};
